@if (this.isData()) {
  <div class="teams-list">
      @for (team of teams; track team.team_id) {
          <div id="{{ team.team_id }}" class="team" (click)="open(team)">
              <div class="team-profile-image">
                  <img [src]="utils.teamImageUrl(team)" alt="{{team.name}}">
              </div>
              <div class="team-name">{{team.name}}</div>
          </div>
      }
  </div>
}
@else {
  <p class="no_data">{{ 'teams.no_team_found' | translate }}</p>
}
